var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconLocation = function SvgIconLocation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#00A0CB",
    fillRule: "evenodd",
    d: "M13.598 6.748c0 3.921-4.748 7.98-5.056 8.24a.797.797 0 0 1-1.087 0c-.308-.26-5.057-4.319-5.057-8.24 0-3.064 2.508-5.548 5.6-5.548 3.093 0 5.6 2.484 5.6 5.548M7.998 9.2a2.4 2.4 0 1 0 0-4.8 2.4 2.4 0 0 0 0 4.8",
    clipRule: "evenodd"
  })));
};
export default SvgIconLocation;